/**
 * Hook providing admin-configured business rules with constant fallbacks
 */
import { useAppSelector } from './useTypedRedux';
import { selectBusinessRules } from '@/store/slices/settingsSlice';
import {
  FREE_SHIPPING_THRESHOLD,
  DEFAULT_SHIPPING_COST,
  GST_RATE,
  MIN_ORDER_VALUE,
  MAX_CART_ITEMS,
} from '@/config/constants';

export const useBusinessRules = () => {
  const rules = useAppSelector(selectBusinessRules);

  return {
    freeShippingThreshold: rules?.freeShippingThreshold ?? FREE_SHIPPING_THRESHOLD,
    defaultShippingCost: rules?.defaultShippingCost ?? DEFAULT_SHIPPING_COST,
    gstRate: rules?.gstRate ?? GST_RATE,
    minOrderValue: rules?.minOrderValue ?? MIN_ORDER_VALUE,
    maxCartItems: rules?.maxCartItems ?? MAX_CART_ITEMS,
  };
};

export default useBusinessRules;
